import {createContext} from "react";

export default createContext({
	billingEntities: [],
	loading: false,
	getBillingEntities: () => {},
	dispatch: () => {}
});
